<template>
  <div class="answer">
    <div class="find">
      <ul class="fit">
        <li
          v-for="(item, index) in List"
          :key="index"
          @click="gofind(index, item.title)"
          :class="{ active: index == current }"
        >
          {{ item.title }}
        </li>
      </ul>
      <!-- <input type="text" placeholder="请输入关键字" v-model="key" />
      <button class="sea" @click="search()">搜索</button> -->
      <a-input-search
        placeholder="请输入关键字"
        class="tosearch"
        @search="search(value)"
      />
      <button class="btnInfo" @click="tonew(answerId)">发起提问></button>
    </div>
    <div class="info">
      <h2>{{ title }}问答</h2>
      <div class="list">
        <answerItem
          :answerList="answerList"
          @todetail="todetail"
          :answerId="answerId"
        ></answerItem>
      </div>
    </div>
    <div class="page">
      <pagination
        :pagination="pagination"
        @changePage="changePage"
      ></pagination>
    </div>
  </div>
</template>

<script>
import { getanswerApi } from "@/request/api";
import answerItem from "./common/answerItem";
import pagination from "./common/pagination";
export default {
  name: "answer",
  components: { answerItem, pagination },
  data() {
    return {
      List: [{ title: "全部" }, { title: "最新" }, { title: "待回复" }],
      current: "",
      keyword: "",
      title: "全部",
      key: "",
      answerList: [],
      index: "",
      answerId: null,
      joined: "",
      info: {
        page: 1,
        pageSize: 6,
        keyword: "",
        orderNew: "",
        needReply: "",
        courseId: "",
      },
      pagination: { total: "", pageSize: 6 },
    };
  },
  computed: {
    isJoined() {
      return this.$store.state.isJoined;
    },
  },
  watch: {
    isJoined: function (val) {
      this.joined = val;
    },
  },
  created() {
    this.answerId = JSON.parse(this.$Base64.decode(this.$route.query.id));
    if(this.$route.query.joined){
      this.joined = JSON.parse(this.$Base64.decode(this.$route.query.joined));
    }
    this.init();
  },

  mounted() {
    window.addEventListener("keydown", this.enterClick, false);
  },
  methods: {
    init() {
      this.info.courseId = this.answerId;
      this.getToken(getanswerApi, this.info, (res) => {
        this.answerList = res.data.rows;
        this.pagination.total = res.data.count;
      });
    },
    enterClick(e) {
      if (e.key === "Enter") {
        this.info.keyword = this.key;
        this.init();
      }
    },
    gofind(index, title) {
      this.current = index;
      this.title = title;

      if (title == "全部") {
        this.info.orderNew = "";
        this.info.needReply = "";
        this.init();
      } else if (title == "最新") {
        this.info.orderNew = 1;
        this.info.needReply = "";
        this.init();
      } else {
        this.info.needReply = 1;
        this.info.orderNew = "";
        this.init();
      }
    },
    search(value) {
      this.info.keyword = value;
      this.init();
    },
    changePage(currentPage) {
      this.Info.page = currentPage;
      this.init();
    },
    //提问
    tonew(id) {
      if (this.joined) {
        this.$router.push({
          path: "/answerNew",
          query: { id:this.$Base64.encode(id), joined: this.$Base64.encode(this.joined) },
        });
      } else {
        this.$message.info("加入此课程才能提问！");
      }
    },
    todetail(newid, id) {
      this.$router.push({ path: "/answerDetail", query: { newid:this.$Base64.encode(newid), id:this.$Base64.encode(id) } });
    },
  },
  destroyed() {
    window.removeEventListener("keydown", this.enterClick, false);
  },
};
</script>
<style lang="stylus">
.anticon[tabindex] {
  cursor: pointer;
  font-size: 20px;
}
</style>
<style lang="stylus" scoped>
.answer {
  .find {
    display: flex;
    align-items: center;
    position: relative;
    height: 50px;
    line-height: 55px;
    // margin-right: 29px;
    border-bottom: solid 1px #eeeeee;

    .fit {
      display: flex;
      color: #666;
      height: 30px;
      background: #fff;
      margin-bottom: 0px;

      li {
        width: 80px;
        height: 30px;
        border: solid 1px #dddddd;
        background-color: #ffffff;
        line-height: 30px;
        text-align: center;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #666;
        margin: 0px -1px 0px 0px;
      }

      li:hover {
        cursor: pointer;
      }

      .active {
        border: solid 1px #000;
        margin: 0px;
        color: #333;
        background: #f0cd48;
      }
    }

    .tosearch {
      outline: none;
      width: 200px;
      height: 30px;
      margin-left: 40px;
    }

    .btnInfo {
      border: 0;
      outline: none;
      width: 128px;
      height: 32px;
      background-color: #f0cd48;
      letter-spacing: 1px;
      color: #333;
      font-size: 14px;
      line-height: 32px;
      text-align: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0px;
    }
  }

  .info {
    overflow: hidden;

    h2 {
      min-width: 59px;
      overflow: hidden;
      height: 18px;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      margin-top: 15px;
      margin-bottom: 10px;
      letter-spacing: 0px;
      color: #333333;
    }

    .list {
      margin: 0 auto;
      min-height: 200px;
      margin-bottom: 30px;
    }
  }

  .page {
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
</style>